module.exports = __webpack_public_path__ + "img/arrow-right-circle.e4c5aac1.svg";